document.addEventListener('DOMContentLoaded', function () {

  /* ---------- Quick Add to Cart ---------- */
  document.querySelectorAll('[data-apc-quick-add]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;

      var spinner = btn.querySelector('.apc-btn-spinner');
      var text = btn.querySelector('.apc-btn-text');
      btn.disabled = true;
      if (spinner) spinner.hidden = false;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function (res) { return res.json(); })
        .then(function () {
          if (text) text.textContent = 'Added!';
          btn.classList.add('is-added');
          showToast('Item added to cart');
          document.dispatchEvent(new CustomEvent('cart:updated'));
          setTimeout(function () {
            if (text) text.textContent = 'Add to Cart';
            btn.classList.remove('is-added');
            btn.disabled = false;
          }, 1800);
        })
        .catch(function () {
          if (text) text.textContent = 'Error - try again';
          btn.disabled = false;
        })
        .finally(function () {
          if (spinner) spinner.hidden = true;
        });
    });
  });

  /* ---------- Wishlist (localStorage based) ---------- */
  var WISHLIST_KEY = 'apc_wishlist';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(list) {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
  }

  function refreshWishlistUI() {
    var list = getWishlist();
    document.querySelectorAll('[data-apc-wishlist]').forEach(function (btn) {
      var id = btn.getAttribute('data-product-id');
      btn.classList.toggle('is-active', list.indexOf(id) !== -1);
    });
  }

  document.querySelectorAll('[data-apc-wishlist]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var id = btn.getAttribute('data-product-id');
      var list = getWishlist();
      var idx = list.indexOf(id);
      if (idx === -1) {
        list.push(id);
        showToast('Added to wishlist');
      } else {
        list.splice(idx, 1);
        showToast('Removed from wishlist');
      }
      saveWishlist(list);
      refreshWishlistUI();
    });
  });

  refreshWishlistUI();

  /* ---------- Color Swatches ---------- */
  document.querySelectorAll('[data-apc-swatches]').forEach(function (group) {
    var swatches = group.querySelectorAll('.apc-swatch');
    swatches.forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        swatches.forEach(function (s) { s.classList.remove('is-selected'); });
        swatch.classList.add('is-selected');

        var variantId = swatch.getAttribute('data-variant-id');
        var card = group.closest('[data-apc-card]');
        if (card && variantId) {
          var quickAddBtn = card.querySelector('[data-apc-quick-add]');
          if (quickAddBtn) quickAddBtn.setAttribute('data-variant-id', variantId);
        }
      });
    });
  });

  /* ---------- Quick View (basic modal) ---------- */
  document.querySelectorAll('[data-apc-quickview]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var handle = btn.getAttribute('data-product-handle');
      if (!handle) return;

      fetch('/products/' + handle + '?view=quick-view')
        .then(function (res) { return res.text(); })
        .then(function (html) {
          openQuickViewModal(html, handle);
        })
        .catch(function () {
          window.location.href = '/products/' + handle;
        });
    });
  });

  function openQuickViewModal(html, handle) {
    var existing = document.getElementById('apc-quickview-modal');
    if (existing) existing.remove();

    var modal = document.createElement('div');
    modal.id = 'apc-quickview-modal';
    modal.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,0.5);z-index:1000;display:flex;align-items:center;justify-content:center;padding:20px;';

    var inner = document.createElement('div');
    inner.style.cssText = 'background:#fff;max-width:600px;width:100%;max-height:85vh;overflow-y:auto;border-radius:8px;padding:24px;position:relative;';
    inner.innerHTML = html || '<p>Unable to load product. <a href="/products/' + handle + '">View product page</a></p>';

    var closeBtn = document.createElement('button');
    closeBtn.textContent = '\u00D7';
    closeBtn.style.cssText = 'position:absolute;top:12px;right:12px;border:none;background:none;font-size:24px;cursor:pointer;line-height:1;';
    closeBtn.addEventListener('click', function () { modal.remove(); });

    inner.appendChild(closeBtn);
    modal.appendChild(inner);
    modal.addEventListener('click', function (e) {
      if (e.target === modal) modal.remove();
    });

    document.body.appendChild(modal);
  }

  /* ---------- Toast ---------- */
  function showToast(message) {
    var existing = document.querySelector('.apc-toast');
    if (existing) existing.remove();

    var toast = document.createElement('div');
    toast.className = 'apc-toast';
    toast.textContent = message;
    document.body.appendChild(toast);

    requestAnimationFrame(function () {
      toast.classList.add('is-visible');
    });

    setTimeout(function () {
      toast.classList.remove('is-visible');
      setTimeout(function () { toast.remove(); }, 300);
    }, 2200);
  }

});
